import React from "react";
import { Link } from "react-router-dom";
import { products, productFeatures } from "@/mock";
import * as Icons from "lucide-react";
import ProductImage from "@/components/ProductImage";

export default function ColorLineup() {
  return (
    <section id="collections" className="bg-[#0a0a0a] text-white py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="text-[11px] tracking-[0.28em] text-[#ff2626] font-bold uppercase mb-3">
            Signature Collection
          </div>
          <h2 className="text-4xl md:text-5xl font-black tracking-tight">
            FOUR COLORS. INFINITE CONFIDENCE.
          </h2>
          <p className="mt-4 text-white/60 max-w-xl mx-auto text-[15px]">
            Every pair carries our signature jacquard waistband and BD leg logo.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {products.map((p) => (
            <Link to={`/products/${p.id}`} key={p.id} className="group block">
              <div className="relative aspect-square overflow-hidden border border-white/10 bg-[#111] flex items-center justify-center">
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "radial-gradient(60% 55% at 50% 45%, rgba(255,255,255,0.05) 0%, rgba(0,0,0,0) 60%)",
                  }}
                />
                <div className="absolute inset-6 md:inset-8 flex items-center justify-center transition-transform duration-500 group-hover:scale-[1.05]">
                  <ProductImage
                    src={p.img}
                    alt={`${p.color} boxer brief`}
                    className="drop-shadow-[0_20px_30px_rgba(0,0,0,0.55)]"
                  />
                </div>
              </div>
              <div className="text-center mt-4 text-[12px] tracking-[0.24em] font-bold uppercase group-hover:text-[#ff2626] transition-colors">
                {p.color}
              </div>
            </Link>
          ))}
        </div>

        {/* Feature icons row */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-5 gap-6">
          {productFeatures.map((f) => {
            const Icon = Icons[f.icon] || Icons.Check;
            return (
              <div key={f.label} className="flex flex-col items-center text-center">
                <div className="h-14 w-14 rounded-full bg-white flex items-center justify-center mb-3">
                  <Icon size={22} className="text-[#c60d0d]" strokeWidth={2.4} />
                </div>
                <div className="text-[11px] tracking-[0.2em] font-bold uppercase whitespace-pre-line">
                  {f.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
